import Vue from 'vue';

document.getElementById('menu-item-locations').classList.add('current-menu-item')

import LocationsApp from '../Scripts/Locations/locationsApp.vue'
// import LocationsApp from '../Content/Scripts/Locations/testLocations.vue'

// import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
// import 'leaflet/dist/leaflet.css';

// Vue.component('l-map', LMap);
// Vue.component('l-tile-layer', LTileLayer);
// Vue.component('l-marker', LMarker);

// import { Icon } from 'leaflet';

// type D = Icon.Default & {
//   _getIconUrl?: string;
// };

// delete Icon.Default.prototype._getIconUrl;
// Icon.Default.mergeOptions({
//   iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
//   iconUrl: require('leaflet/dist/images/marker-icon.png'),
//   shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
// });


new Vue({
    el:"#app",
    components: {
        LocationsApp
    },
    data() {
        return {
            locations: (window as any).locations
        }
    },
    template: '<locations-app :locations="locations"></locations-app>'
})